import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { KENDO_LOADER } from '@progress/kendo-angular-indicators';
import { loading$ } from 'src/app/core/contracts';
import { BaseComponent } from '../base-component/base.component';

@Component({
  selector: 'loading',
  standalone: true,
  imports: [AsyncPipe, KENDO_LOADER],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
})
export class LoadingComponent extends BaseComponent implements OnInit {
  loading = loading$; /* .pipe( NOTE: added to avoid showing and hiding loading for a split second, but sometimes causes the loading to remain shown
    // Attach a timestamp to each emission
    timestamp(),

    // tap(value => this.logger?.styledLog({ msg: '@pre-filter:', params: { value, timestamp: new Date().valueOf() } })),

    // Pair each emission with its previous emission
    pairwise(),

    // Filter out pairs that are emitted too close to each other and are different
    filter(([a, b]) => {
      const timeDiff = b.timestamp - a.timestamp;
      const MAX_TIME_DIFF = 90; // Adjust this value as needed

      // Check both time difference and distinctness of values
      return timeDiff > MAX_TIME_DIFF && a.value !== b.value;
    }),

    // Transform the filtered emissions back to their original form
    switchMap(([, latest]) => {
      return of(latest.value);
    })

    // tap(value => this.logger?.styledLog({ msg: '@loader', params: { value, timestamp: new Date().valueOf() } }, 'brown'))
  ); */
  constructor() {
    super();
  }
  override ngOnInit(): void {}
}
